// extracted by mini-css-extract-plugin
export default {"socialContainer":"styles_socialContainer__6LcgE","socialBtn":"styles_socialBtn__zclc1"};